export var SingletonInter = {
    instance: function() {
        if (!SingletonInter.instance) {
            SingletonInter.instance = this;
        }
        return SingletonInter.instance;
    },

    $t: () => {},

}